import { useEffect, useState } from 'react'
import { Embroidery, PartialAction, PartialShoesAction } from 'src/types'
import { useDebounce } from 'use-debounce'

const embroideriesReducer = (embroideries: Embroidery[], newEmbroideries: Embroidery, i: number): Embroidery[] => {
  return embroideries.reduce((a: Embroidery[], c) => {
    if (c.id === i) a.push(newEmbroideries)
    if (c.id !== i) a.push(c)
    return a
  }, [])
}

export const useEmbroideryContent = (
  dispatch: (value: PartialAction | PartialShoesAction) => void,
  embroideries: Embroidery[]
): ((content: string, i: number) => void) => {
  const [content, setContent] = useState('')
  const [contentNum, setContentNum] = useState(0)
  const [delayedValue] = useDebounce(content, 10)
  const handleContentAndNum = (content: string, i: number) => {
    setContent(content)
    setContentNum(i)
  }

  // テキストの遅延更新処理ここから
  const SET_EMBROIDERIES = 'setEmbroideries'
  const updateEmbroideryContent = (delayedValue: string, i: number) => {
    const newEmbroideries = { ...embroideries[i], content: delayedValue }
    return embroideriesReducer(embroideries, newEmbroideries, i)
  }
  useEffect(() => {
    // 抽象化したい
    dispatch({ type: SET_EMBROIDERIES, embroideries: updateEmbroideryContent(delayedValue, contentNum) })
  }, [delayedValue])
  // テキストの遅延更新処理ここまで
  return handleContentAndNum
}
